module.exports = __webpack_public_path__ + "static/pitpayicon-31496fa8ceb234dda46cebcd4aadd968.svg";